import { Component, Vue, Watch } from "vue-property-decorator";

import * as firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import ConfirmDlg from "@/components/popup/confirm-dialog/ConfirmDlg.vue";
import ConfirmMessageDlg from "@/components/popup/confirm-message-dialog/ConfirmMessageDlg.vue";
import Loader from "@/components/loader/Loader.vue";
import { ServiceTypeEnum } from "@/enums/ServiceTypeEnum";
import { EventsTypes } from "@/enums/EventsTypes";
import { ServiceTypeIntegrationEnum } from "@/enums/ServiceTypeIntegrationEnum";
import ManipulateCalendarEventDialog from "@/views/calender/manipulate-calendar-event-dialog/ManipulateCalendarEventDialog.vue";
import EditEvent from "../../calender/edit-simple-event-dialog/EditEvent.vue";
import EditEventSeries from "../../calender/edit-event-series-dialog/EditEventSeries.vue";
import moment from "moment";
import { ValidationRules } from "@/utils/validation-rules";
import { PremiumServiceEventTypes } from "@/enums/PremiumServiceEventTypes";
import { API } from "@/api";
import { getRegionName } from "@/utils/functionsRegion";
import { PremiumServiceParticipantsLimit } from "@/enums/PremiumServiceParticipantsLimit";
import { ServiceStatus } from "@/enums/ServiceStatus";
import DeleteServiceDialog from "@/views/premium-services/delete-premium-service-dialog/DeletePremiumServiceDialog.vue";
import { getFormattedDateTimeString } from "@/utils/dateTimeFormat";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { DefaultEmailTemplateType } from "@/enums/DefaultEmailTemplateType";
import { ChargeOccurrenceType } from "@/enums/ChargeOccurrenceType";
import { toTranslationKey } from "@/utils/stringFormat";
import BusinessHours from 'vue-business-hours';
import { slotDurationsInMins } from "@/consts/SlotDurationsInMins";
import { isPremiumServiceAvailableHoursValid, premiumServiceAvailableHours, sortPremiumServiceAvailableHours } from "@/consts/PremiumServiceAvailableHours";
import { timeFormat } from "@/consts/DateTimeFormats";
import { vueBusinessHoursTranslations } from "@/locales/npms/vue-business-hours/vue-business-hours";
import GalleryPhotosUploadDlg from "@/views/staff/gallery/GalleryPhotosUploadDlg/GalleryPhotosUploadDlg.vue";
import {batchUpdate} from "@/utils/batchUpdate";
import router from "@/router";
import {GalleryImage} from "@/models/GalleryImage";

@Component({
  components: {
    BusinessHours,
    ConfirmDlg,
    ManipulateCalendarEventDialog,
    EditEvent,
    EditEventSeries,
    Loader,
    ConfirmMessageDlg,
    DeleteServiceDialog,
    ValidationObserver,
    ValidationProvider,
    GalleryPhotosUploadDlg
  }
})
export default class PremiumProgramView extends Vue {
  serviceTypeEnum = ServiceTypeEnum;
  serviceTypes = Object.values(ServiceTypeEnum).map(x => ({ text: toTranslationKey(x), value: x }));
  eventsTypes = EventsTypes;
  integrationTypes = ServiceTypeIntegrationEnum;
  chargeOccurrenceTypes = Object.values(ChargeOccurrenceType).map(x => ({ text: x, value: x }))
  premiumServiceEventItems = Object.values(PremiumServiceEventTypes).filter(x => [PremiumServiceEventTypes.Request, PremiumServiceEventTypes.Event, PremiumServiceEventTypes.Product].includes(x)).map(x => ({ text: toTranslationKey(x), value: x }))
  profilePicUploadStatus = 100;
  public premiumServiceParticipantsLimitItems = []
  public limitPerTimeSlotItem = { text: toTranslationKey(PremiumServiceParticipantsLimit.LimitPerTimeSlot), value: PremiumServiceParticipantsLimit.LimitPerTimeSlot }
  public nowDate = moment(new Date());
  public selectedEvent = null;
  public isOpenEditing = false;
  public isOpenSeriesEditing = false;
  public isPremiumServiceAvailableHoursValid = true
  public emailTemplatesForVendors = []
  loading = true;
  loadingChange = false;
  loadedVendorsData = false
  slotDurationsInMins = slotDurationsInMins
  searchCategoryInput = ''
  listPremiumApps = [];

  headers = [
    {
      text: this.$i18n.messages[this.$i18n.locale]['EditPremiumService.Event'],
      sortable: false,
      align: "start",
      value: "name",
      width: 230
    },
    {
      text: this.$i18n.messages[this.$i18n.locale]['EditPremiumService.DateAndTime'],
      sortable: false,
      value: "start",
      width: 100
    },
    {
      text: "",
      value: "id",
      width: 120
    }
  ];

  oneOffCost = 0;
  @Watch('oneOffCost')
  onOneOffCost(newValue) {
    this.additionalService.oneOffCost = newValue;
  }

  subscribeCost = 0;
  @Watch('subscribeCost')
  onSubscribeCost(newValue) {
    this.additionalService.subscriptionCost = newValue;
  }

  async created() {
    this.loading = true;

    Promise.all([
      await this.$store.dispatch("getAdditionalService", this.$route.params.id),
      this.$store.dispatch("getAdditionalServiceCategories"),
      this.$store.dispatch("getCurrentAdditionalServiceEvents", {
        additionalServiceId: this.$route.params.id
      }),
      this.$store.dispatch("getFacility"),
      this.$store.dispatch("getAdditionalServices"),
      this.getOrganisationListPremiumAppps(),
      this.loadVendorsData(),
      this.setCostServices(),
    ]).then(() => {
      if (this.additionalService.availableHours) {
        this.additionalService.availableHours = sortPremiumServiceAvailableHours(this.additionalService.availableHours)
      }

      if (this.additionalService.type == PremiumServiceEventTypes.ByAppointment) {
        this.premiumServiceParticipantsLimitItems = Object.values(PremiumServiceParticipantsLimit).map(x => ({ text: toTranslationKey(x), value: x }))
      }
      else {
        this.premiumServiceParticipantsLimitItems = Object.values(PremiumServiceParticipantsLimit).filter(x => x !== PremiumServiceParticipantsLimit.LimitPerTimeSlot).map(x => ({ text: toTranslationKey(x), value: x }))
      }

      this.loading = false;
    })
  }

  get oneOffMembers() {
    const result = this.additionalService?.membersList?.filter(x => x.isOneOff);
    return result ? result : [];
  }

  get notOneOffMembers() {
    const result = this.additionalService?.membersList?.filter(x => !x.isOneOff);
    return result ? result : [];
  }

  get additionalService() {
    const additionalService = this.$store.state.additionalServicesModule
      .additionalService;
    additionalService.type =
      additionalService.type || PremiumServiceEventTypes.EventBased;

    return additionalService;
  }

  get additionalServices() {
    const additionalServices = this.$store.state.additionalServicesModule.additionalServices;

    if(
      [
        PremiumServiceEventTypes.EventBased,
        PremiumServiceEventTypes.ConciergeEvent,
        PremiumServiceEventTypes.Event
      ].includes(this.additionalService.type)
    ) {
      return additionalServices.filter(x => [
        PremiumServiceEventTypes.EventBased,
        PremiumServiceEventTypes.ConciergeEvent,
        PremiumServiceEventTypes.Event
      ].includes(x.type)).sort((a, b) => {
        if(a.orderIndex < b.orderIndex) { return -1; }
        if(a.orderIndex > b.orderIndex) { return 1; }
        return 0;
      })
    }

    if(
      [
        PremiumServiceEventTypes.ByAppointment,
        PremiumServiceEventTypes.AppAccess,
        PremiumServiceEventTypes.Request
      ].includes(this.additionalService.type)
    ) {
      return additionalServices.filter(x => [
        PremiumServiceEventTypes.ByAppointment,
        PremiumServiceEventTypes.AppAccess,
        PremiumServiceEventTypes.Request
      ].includes(x.type)).sort((a, b) => {
        if(a.orderIndex < b.orderIndex) { return -1; }
        if(a.orderIndex > b.orderIndex) { return 1; }
        return 0;
      })
    }

    if(
      [
        PremiumServiceEventTypes.Gift,
        PremiumServiceEventTypes.Product
      ].includes(this.additionalService.type)
    ) {
      return additionalServices.filter(x => [
        PremiumServiceEventTypes.Gift,
        PremiumServiceEventTypes.Product
      ].includes(x.type)).sort((a, b) => {
        if(a.orderIndex < b.orderIndex) { return -1; }
        if(a.orderIndex > b.orderIndex) { return 1; }
        return 0;
      })
    }
  }

  get additionalServiceCategories() {
    return this.$store.state.additionalServicesModule
      .additionalServiceCategories;
  }

  get selectedFacility() {
    return this.$store.state.facilityModule.selectedFacility;
  }

  get currentFacility() {
    return this.$store.state.authModule.currentFacility;
  }

  get currentAdditionalServiceAllEvents() {
    return this.$store.state.additionalServicesModule
      .currentAdditionalServiceAllEvents;
  }

  get isParticipantLimitTypesSetLimit() {
    return this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.SetLimit;
  }

  get isParticipantLimitTypesLimitPerTimeSlot() {
    return this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.LimitPerTimeSlot;
  }

  get rules(): object {
    return {
      name: [ValidationRules.required, ValidationRules.max(25)],
      selection: [ValidationRules.required],
      slotDurationInMins: [ValidationRules.required]
    };
  }

  public get facilityCurrency() {
    return this.$store.getters.facilityCurrency;
  }

  get PremiumServiceEventTypes() {
    return PremiumServiceEventTypes;
  }

  get isServiceNotConciergeEvent() {
    return this.additionalService.type != this.PremiumServiceEventTypes.ConciergeEvent;
  }

  get PremiumServiceParticipantsLimitTypes() {
    return PremiumServiceParticipantsLimit;
  }

  get isWaitingList() {
    if (this.additionalService.participantLimit) {
      return this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.SetLimit;
    }
  }

  get vendorEnabledEmailTemplates() {
    return this.$store.state.facilityModule.currentEmailTemplates.filter(x => x.isEnabled === true && x.type == DefaultEmailTemplateType.ServiceRequestToVendor);
  }

  get currentVendors() {
    return this.$store.state.additionalServicesModule.currentVendors;
  }

  get isHourFormat24() {
    return this.$store.state.facilityModule.selectedFacility.timeFormat === timeFormat.h24
  }

  get localization() {
    return vueBusinessHoursTranslations[this.$i18n.locale]
  }

  get showAddCategoryBtn() {

    const value = this.searchCategoryInput ? this.searchCategoryInput.trim().toLocaleLowerCase() : ''

    if (value.length <= 0) return false

    const existed = this.additionalServiceCategories[0].categories.some(x => x.trim().toLocaleLowerCase() === value)

    return !existed
  }

  async addCategory() {

    if (!this.additionalServiceCategories[0]) return

    const value = this.searchCategoryInput?.trim() || null

    if (!value || value?.length <= 0) return

    if (this.additionalServiceCategories[0].categories.some(x => x === value)) return

    this.additionalServiceCategories[0].categories.push(value)

    await this.$store.dispatch("upsertAdditionalServiceCategories", this.additionalServiceCategories[0])
      .then(() => {
        this.additionalService.category = value
        this.$toast.open({
          message: this.$t('CreatePremiumService.CategorySuccessfullyAddedMessage') as string,
          type: "success"
        });
      }).catch((error) => {
        console.error(error)
        this.$toast.open({ message: this.$t('GeneralTranslations.UndefinedError') as string, type: "error" });
      });
  }

  public incrementParticipantLimitNumber(): void {
    if (!this.additionalService.participantLimitNumber) {
      this.additionalService.participantLimitNumber = 1;
    } else {
      this.additionalService.participantLimitNumber++;
    }
    this.$forceUpdate();
  }

  public decrementParticipantLimitNumber(): void {
    if (this.additionalService.participantLimitNumber > 1) {
      this.additionalService.participantLimitNumber--;
      this.$forceUpdate();
    }

    if (!this.additionalService.participantLimitNumber) {
      this.additionalService.participantLimitNumber = 1;
      this.$forceUpdate();
    }
  }

  public incrementMaxSlots(): void {
    if (!this.additionalService.maxSlots) {
      this.additionalService.maxSlots = 1
    }
    else {
      this.additionalService.maxSlots++
    }

    this.$forceUpdate();
  }

  public decrementMaxSlots(): void {
    if (this.additionalService.maxSlots > 1) {
      this.additionalService.maxSlots--;
      this.$forceUpdate();
    }
    if (!this.additionalService.maxSlots) {
      this.additionalService.maxSlots = 1
      this.$forceUpdate();
    }
  }

  beforeDestroy() {
    this.$store.dispatch("clearCurrentAdditionalService");
    this.$store.dispatch("clearCurrentCalenderRecurringEvents");
  }

  routeToPremiumServices(): void {
    this.$router.push(`concierge-service`);
  }

  routeToServiceRequest(id): void {
    this.$router.push("/services/" + id);
  }

  async loadVendorsData() {
    if (!this.loadedVendorsData) {
      await this.$store.dispatch("getEmailTemplates");
      await this.$store.dispatch("getVendors");
      this.loadedVendorsData = true
    }
  }

  async onChangeSendVendorEmailOption(e) {
    if (e === true) {
      this.additionalService.sendVendorEmailOptions = {
        vendorId: null,
        vendorName: null,
        emailTemplateId: null
      }
      await this.loadVendorsData()
    }
    else {
      this.additionalService.sendVendorEmailOptions = null
    }
  }

  onVendorSelected(vendorId) {
    const vendor = this.currentVendors.find(x => x.id == vendorId)
    this.additionalService.sendVendorEmailOptions.vendorName = vendor.name
  }

  onTypeChange() {
    this.additionalService.participantLimit = null
    if (this.additionalService.type === PremiumServiceEventTypes.ByAppointment) {
      this.premiumServiceParticipantsLimitItems.push(this.limitPerTimeSlotItem)
      this.additionalService.availableHours = premiumServiceAvailableHours
    }
    else {
      this.additionalService.slotDurationInMins = null
      const index = this.premiumServiceParticipantsLimitItems.indexOf(this.limitPerTimeSlotItem);
      if (index !== -1) {
        this.premiumServiceParticipantsLimitItems.splice(index, 1);
      }
    }
  }

  onUpdatedHours(data) {
    const editedPropsNames = Object.keys(data);

    if (!editedPropsNames || editedPropsNames?.length > 1) {
      throw Error('Unhandled error during updating the business-hours')
    }

    const editedDayPropName = editedPropsNames[0]
    const editedDayObj = data[editedDayPropName]
    this.additionalService.availableHours[editedDayPropName] = editedDayObj
    this.isPremiumServiceAvailableHoursValid = isPremiumServiceAvailableHoursValid(this.additionalService.availableHours)
  }

  async saveChanges() {
    const form = this.$refs.form as any;
    const validated = form.validate();

    if (!validated || !this.isPremiumServiceAvailableHoursValid) return;

    //cast to string for MyHub
    this.additionalService.noticePeriod = this.additionalService.noticePeriod ? this.additionalService.noticePeriod.toString() : ''
    this.additionalService.oneOffCost = this.additionalService.oneOffCost ? this.additionalService.oneOffCost.toString() : ''
    this.additionalService.subscriptionCost = this.additionalService.subscriptionCost ? this.additionalService.subscriptionCost.toString() : ''

    this.loadingChange = true;
    await this.$store.dispatch("updateAdditionalService", this.additionalService);
    await this.$store.dispatch("getCurrentAdditionalServiceEvents", {
      additionalServiceId: this.additionalService?.id
    })
    await this.$store.dispatch("getAdditionalServices");
    this.loadingChange = false;
  }

  async deleteService() {
    await this.$store.dispatch("getAdditionalServiceRequestsByServiceId", this.additionalService.id);
    const requests = await this.$store.state.additionalServicesModule.serviceRequestByServiceId;
    let isRemovePremiumService = true;

    (this.$refs.confirmationMessageModal as any)
        .open(
            null,
            (this.$i18n.messages[this.$i18n.locale]['EditPremiumService.DeleteMessage'] as string).replace('[serviceType]', 'service'),
            false,
            "",
            null,
            `${(this.$i18n.messages[this.$i18n.locale]['EditPremiumService.SuccessDeleteMessage'] as string).replace('[serviceType]', 'service')} "${this.additionalService.name}"`,
            (this.$i18n.messages[this.$i18n.locale]['EditPremiumService.ServiceHasOpenRequestMessage'] as string)
                .replace('[additionalServiceName]', 'service')
                .replace('[eventNames]',  'bookings')
            ,
            this.$i18n.messages[this.$i18n.locale]['EditPremiumService.Loading'],
            this.additionalService.id
        )
      .then(async response => {
        if (response && response.agree) {

          requests.forEach((item) => {
            if (
              item.status === ServiceStatus.AwaitingApproval ||
              item.status === ServiceStatus.Approved
            ) {
              isRemovePremiumService = false;
            }
          })

          if (isRemovePremiumService) {
            await this.$store.dispatch("deleteAdditionalService",  { additionalServiceId: this.additionalService.id, office365EventId: this.additionalService?.office365EventId })
              .then(async () => {
                await this.changeOrderIndexesForServices();
                this.routeToPremiumServices();
              })
          } else {
            (this.$refs.confirmationMessageModal as any).error();
          }
        }
      });
  }

  async changeOrderIndexesForServices() {
    console.log("START Change Order Indexes For Services")
    console.log(this.additionalServices)

    const itemsToUpdate = this.additionalServices
      .filter(x => x.id !== this.$route.params.id)
      .map((item, index) => {
        return { docId: item.id, updates: { orderIndex: index + 1 } };
    })

    console.log("itemsToUpdate")
    console.log(itemsToUpdate)

    await batchUpdate('additionalServices', itemsToUpdate).then(() => {
      this.loading = false;
    })
  }

  remove(restrictedResidents, item): void {
    const index = restrictedResidents.indexOf(item.id);
    if (index >= 0) restrictedResidents.splice(index, 1);
  }

  setCostServices() {
    if (this.additionalService.oneOffCost && this.additionalService.oneOffCost !== 'POA') {
      this.oneOffCost = this.additionalService?.oneOffCost;
    }

    if (this.additionalService.subscriptionCost && this.additionalService?.subscriptionCost !== 'POA') {
      this.subscribeCost = this.additionalService?.subscriptionCost;
    }
  }

  saveProfilePic(e) {
    const ref = uuidv4();

    const storageRef = firebase
      .storage()
      .ref()
      .child(this.currentFacility)
      .child("additionalServices")
      .child("images")
      .child(ref)
      .put(e.target.files[0]);

    storageRef.on(
      `state_changed`,
      snapshot => {
        this.profilePicUploadStatus =
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
      },
      error => {
        console.error(error.message);
      },
      () => {
        storageRef.snapshot.ref.getDownloadURL().then(url => {
          this.additionalService.imageUrl = url;
        });
      }
    );

    this.saveChanges();
  }

  loadEvents(): void {
    this.$store.dispatch("getCurrentAdditionalServiceEvents", {
      additionalServiceId: this.additionalService?.id
    });
  }
  loadRecurringEvents(eventId): void {
    this.$store.dispatch("clearCurrentCalenderRecurringEvents");
    this.$store.dispatch("getCalenderRecurringEvents", eventId);
  }
  selectEvent(event) {
    this.selectedEvent = event;
    this.isOpenEditing = true;
  }

  selectRecurringEvent(event) {
    this.selectedEvent = event;
    this.isOpenSeriesEditing = true;
  }

  unsubscribe(item) {
    console.log(`unsubscribing: ${item.id}`);

    //to immediately see changes on the UI
    this.additionalService.membersList = this.additionalService?.membersList.filter(
      x => x.id !== item.id
    );

    //really unsubscribe
    firebase.app().functions(getRegionName())
      .httpsCallable("unsubscribeAdditionalService")({
        memberId: item.id,
        additionalServiceId: this.$route.params.id,
        staffUserName: this.$store.state.authModule.user.name
      })
      .then(async () => {
        await this.$store.dispatch(
          "getAdditionalService",
          this.$route.params.id
        );
        console.log("unsubscribed");
      });
  }

  async onEventUpdate(event) {
    await this.$store.dispatch("updateSingleCalenderEvent", {
      event,
      id: this.additionalService?.id
    });
    this.isOpenEditing = false;
    this.selectedEvent = null;
    this.loadEvents();
  }

  async onEventSeriesUpdate(eventData) {
    if (!eventData.event.isRecurring) return;

    await this.$store.dispatch("updateCalenderEvent", eventData);
  }

  afterUpdate(updatedEvents) {
    this.isOpenSeriesEditing = false;
    this.selectedEvent = null;
    this.loadRecurringEvents(updatedEvents[0].id);
    this.loadEvents();
  }

  deleteEvent({id, isRecurring, office365EventId}) {

    (this.$refs.confirmationModal as any)
      .open(null, this.$i18n.messages[this.$i18n.locale]['EditPremiumService.DeleteEventMessage'], false)
      .then(async response => {
        if (response && response.agree) {
          await this.$store.dispatch("deleteCalenderEvent", {id, isRecurring: isRecurring, office365EventId});
          this.isOpenEditing = false;
          this.isOpenSeriesEditing = false;
          this.selectedEvent = null;

          this.loadEvents();
        }
      });
  }

  async getOrganisationListPremiumAppps() {

    const organisation = await API.organisations.getOrganisationById(this.selectedFacility.orgId);

    this.listPremiumApps = organisation.listPremiumApps;
  }

  deleteEventSeries(parentEventId) {
    (this.$refs.confirmationModal as any)
      .open(null,
        this.$i18n.messages[this.$i18n.locale]['EditPremiumService.DeleteEventSeriesMessage']
        , false)
      .then(async response => {
        if (response && response.agree) {
          await this.$store.dispatch(
            "deleteCalenderEventSeries", {
            parentEventId: parentEventId,
            deleteUpcomingEvents: false,
          }

          );
          this.isOpenEditing = false;
          this.isOpenSeriesEditing = false;
          this.selectedEvent = null;

          this.loadEvents();
        }
      });
  }

  onChangeParticipantLimit() {
    if (this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.Unlimited) {
      this.additionalService.isWaitingList = false;
    }

    if (this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.SetLimit) {
      this.additionalService.participantLimitNumber = 1
    }
    else {
      this.additionalService.participantLimitNumber = null
    }

    if (this.additionalService.participantLimit === this.PremiumServiceParticipantsLimitTypes.LimitPerTimeSlot) {
      this.additionalService.maxSlots = 1
    }
    else {
      this.additionalService.maxSlots = null
    }

    this.$forceUpdate();
  }

  formattedDateTimeString(date: Date, addYears: boolean, addTime: boolean) {
    if (!this.selectedFacility) return ''

    return getFormattedDateTimeString(date, this.selectedFacility.dateFormat, addTime ? this.selectedFacility.timeFormat : null, addYears);
  }

  openGalleryPhotos() {
    (this.$refs.GalleryPhotosUploadDlg as any).open();
  }

  uploadGalleryPhoto(image: GalleryImage) {
    this.additionalService.imageUrl = image.image;
    this.additionalService.thumbnailUrl = image?.thumbnailUrl ?? image.image;
  }
}
